var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSixth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 42.43 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 21.21,
    cy: 21.21,
    r: 21.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.2,15.73c-.34-.32-.83-.48-1.47-.48-.98,0-1.68,.42-2.11,1.27-.43,.85-.65,2.19-.67,4.02,.38-.6,.92-1.07,1.63-1.41s1.5-.51,2.35-.51c1.68,0,3.03,.53,4.05,1.59,1.02,1.06,1.53,2.54,1.53,4.45,0,1.25-.25,2.35-.76,3.29-.51,.94-1.24,1.68-2.21,2.21s-2.11,.8-3.43,.8c-2.64,0-4.47-.83-5.5-2.48-1.03-1.65-1.54-4.03-1.54-7.14,0-3.26,.54-5.68,1.63-7.26,1.09-1.59,2.83-2.38,5.23-2.38,1.29,0,2.37,.25,3.25,.76,.88,.51,1.55,1.17,2.01,1.99,.45,.82,.72,1.72,.81,2.7h-4.09c-.14-.63-.38-1.11-.72-1.43Zm-3.15,7.02c-.49,.44-.73,1.06-.73,1.86s.23,1.47,.68,1.93c.45,.46,1.1,.69,1.94,.69,.75,0,1.35-.23,1.79-.68,.44-.45,.66-1.08,.66-1.86s-.21-1.44-.64-1.9-1.05-.69-1.85-.69c-.74,0-1.35,.22-1.84,.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.63,18.72h-5.8c.04,.52,.21,.92,.5,1.19,.29,.28,.66,.41,1.09,.41,.64,0,1.08-.27,1.33-.81h2.73c-.14,.55-.39,1.04-.76,1.48-.37,.44-.82,.79-1.37,1.04-.55,.25-1.17,.38-1.84,.38-.82,0-1.55-.18-2.19-.53-.64-.35-1.14-.85-1.5-1.5-.36-.65-.54-1.41-.54-2.28s.18-1.63,.53-2.28c.35-.65,.85-1.15,1.49-1.5,.64-.35,1.38-.53,2.21-.53s1.53,.17,2.16,.51c.63,.34,1.12,.82,1.48,1.46,.36,.63,.53,1.36,.53,2.2,0,.24-.02,.49-.04,.75Zm-2.58-1.42c0-.44-.15-.79-.45-1.05-.3-.26-.67-.39-1.12-.39s-.79,.12-1.09,.38-.48,.6-.55,1.06h3.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixth);
export default __webpack_public_path__ + "static/media/sixth.0f233b513d9ad06d313a1d2f2acc413c.svg";
export { ForwardRef as ReactComponent };